import { useSites } from '../../hooks/useSites';
import { useMemo } from 'react';
import { FormSelectOption } from '../../components/form/FormSelect';
import { Site } from '../../sites/dto/Site';

export function useDashboardSiteSelectOptions(): FormSelectOption<Site>[] {
  const { data = [] } = useSites();

  return useMemo(
    () =>
      data.map((site) => ({
        label: site.name,
        value: site,
      })),
    [data],
  );
}
